interface TitleComponentProps {
    title: React.ReactNode;
    className?: string;
}

const TitleComponent = ({ title, className }: TitleComponentProps) => {

    return (
        <h5 
            className={`border-b-[15px] p-[15px] border-[#007167] text-xl ${className || ""}`}
        >
            {title}
        </h5>
    );
}

export default TitleComponent;